import { render, staticRenderFns } from "./siding-options.vue?vue&type=template&id=f2887c78&scoped=true"
import script from "./siding-options.vue?vue&type=script&lang=js"
export * from "./siding-options.vue?vue&type=script&lang=js"
import style0 from "./siding-options.vue?vue&type=style&index=0&id=f2887c78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2887c78",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VImg,VRow})
